import { ImageService } from './../../services/image/image.service';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ig-image-selector',
  templateUrl: './image.selector.component.html',
  styleUrls: ['./image.selector.component.scss'],
})
export class ImageSelectorComponent {
  selectedImageData;
  isImageChanged: boolean = false;
  selectedImageSize = {
    width: 0,
    height: 0,
  };

  @Input() compressWidth = 1200;
  @Input() public disabled: boolean = false;
  @Input() public accept: string = 'image/png,image/gif,image/jpeg'; // Accepted file types
  @Input() public formatTip: string =
    'Please upload images in JPG, PNG or WEBP format. Landscape images recommended'; // Custom format tip
  @Output() public onImageChanged = new EventEmitter<any>();

  @ViewChild('imageSelector') imageSelector: any;

  constructor(public imgService: ImageService) {}

  public onImageChange($event) {
    const file = $event.srcElement.files[0];
    if (!!file) {
      // Validate file type against accepted types
      const acceptedTypes = this.accept.split(',').map((type) => type.trim());
      const fileType = file.type;

      if (!acceptedTypes.includes(fileType)) {
        alert(
          `Invalid file type. Please upload only: ${this.accept
            .replace(/image\//g, '')
            .toUpperCase()}`
        );
        $event.target.value = ''; // Clear the input
        return;
      }

      let reader = new FileReader();

      reader.onload = async (e) => {
        this.selectedImageData = e.target['result'];
        const imageFile = await this.imgService.compressImageFile(file, this.compressWidth);
        this.selectedImageSize = await this.imgService.getImageFileSize(file);
        this.onImageChanged.emit(imageFile);
      };

      reader.readAsDataURL(file);
      this.isImageChanged = true;
    }
  }

  public clear() {
    this.selectedImageData = null;
  }

  public click() {
    this.imageSelector.nativeElement.click();
  }
}
